module.exports = __webpack_public_path__ + "static/media/user-file-upload.acfd7e2f.svg";